import { Col, Divider, Row, Typography } from "antd";
import ColorConsumption from "../../../components/Admin/AdminPanel/ColorConsumption";
import ColorPrices from "../../../components/Admin/AdminPanel/ColorPrices";
import Foil from "../../../components/Admin/AdminPanel/Foil";
import Hotprint from "../../../components/Admin/AdminPanel/Hotprint";
import MachinesTable from "../../../components/Admin/AdminPanel/MachinesTable";
import ProductionCosts from "../../../components/Admin/AdminPanel/ProductionCosts";
import Rastra from "../../../components/Admin/AdminPanel/Rastra";
import Relief from "../../../components/Admin/AdminPanel/Relief";
import VarnishTable from "../../../components/Admin/AdminPanel/VarnishTable";
const { Title } = Typography;

const TilteSize = 3;

export default function AdminData() {
   return (
      <div style={{ margin: "15px" }}>
         <Row gutter={16}>
            <Col span={24}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Machines
               </Title>
               <MachinesTable />
            </Col>
            <Divider />
            <Col span={12}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Varnish
               </Title>
               <VarnishTable />
            </Col>

            <Col span={12}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Foil
               </Title>
               <Foil />
            </Col>
            <Divider />
            <Col span={24}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Hotprint
               </Title>
               <Hotprint />
            </Col>
            <Divider />
            <Col span={12}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Relief
               </Title>
               <Relief />
            </Col>
            <Col span={12}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Rastra
               </Title>
               <Rastra />
            </Col>
            <Divider />
            <Col span={24}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Production Costs
               </Title>
               <ProductionCosts />
            </Col>
            <Divider />
            <Col span={12}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Color Prices
               </Title>
               <ColorPrices />
            </Col>
            <Col span={12}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Adjustment T.M.
               </Title>
               <ColorPrices />
            </Col>
            <Divider />
            <Col span={24}>
               <Title style={{ marginLeft: "5px" }} level={TilteSize}>
                  Color Consumption
               </Title>
               <ColorConsumption />
            </Col>
         </Row>
      </div>
   );
}
